
function createCookie(name,value,days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime()+(days*24*60*60*1000));
        expires = "; expires="+date.toGMTString();
    }
    document.cookie = name+"="+value+expires+"; path=/;"
}

function getCookie(name) {
  var value = "; " + document.cookie;
  var parts = value.split("; " + name + "=");
  if (parts.length == 2) return parts.pop().split(";").shift();
}

var banner = document.getElementsByClassName('cookies__banner')[0];

banner.getElementsByClassName('close')[0].addEventListener('click', (e) => {
    e.preventDefault();
    createCookie('banner__seen', 'true', 90);
    banner.classList.remove('view');
});

banner.querySelector('p a').addEventListener('click', (e) => {
    createCookie('banner__seen', 'true', 90);    
});

document.addEventListener('DOMContentLoaded', () => {
    if (getCookie('banner__seen')){
        createCookie('banner__seen', 'true', 90);
    } else {
        banner.classList.add('view');
    }
});


